import { useState } from "react"
import { useTranslation } from "react-i18next"

export const AddItemSelector = ({ onSelect }) => {
    const { i18n } = useTranslation()
    const [showOptions, setShowOptions] = useState(false)

    const handleSelect = (type) => {
        setShowOptions(false)
        onSelect(type)
    }

    if (showOptions) {
        return (
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 min-w-[120px] flex flex-col items-center justify-center gap-2">
                <button
                    className="w-full px-3 py-2 text-sm bg-blue-50 text-blue-700 rounded hover:bg-blue-100 transition-colors"
                    onClick={() => handleSelect('product')}
                >
                    {i18n.t('container_templates.editor.add_product')}
                </button>
                <button
                    className="w-full px-3 py-2 text-sm bg-purple-50 text-purple-700 rounded hover:bg-purple-100 transition-colors"
                    onClick={() => handleSelect('sub_container')}
                >
                    {i18n.t('container_templates.editor.add_sub_container')}
                </button>
                <button
                    className="text-xs text-gray-400 hover:text-gray-600 mt-1"
                    onClick={() => setShowOptions(false)}
                >
                    {i18n.t('container_templates.cancel')}
                </button>
            </div>
        )
    }

    return (
        <div
            className="border-2 border-dashed border-gray-300 rounded-lg p-4 min-w-[120px] flex flex-col items-center justify-center cursor-pointer hover:border-gray-400 hover:bg-gray-50 transition-colors"
            onClick={() => setShowOptions(true)}
        >
            <div className="text-2xl text-gray-400">+</div>
            <div className="text-xs text-gray-500">{i18n.t('container_templates.editor.add_item')}</div>
        </div>
    )
}
